import { SUB_SERVICE_ORDER_STATUS } from '../constants'

export const statusFilterOptions = [
  { value: SUB_SERVICE_ORDER_STATUS.ALL, label: 'ALL' },
  { value: SUB_SERVICE_ORDER_STATUS.NEW, label: 'NEW' },
  {
    value: SUB_SERVICE_ORDER_STATUS.WAITING_FOR_USER,
    label: 'WAITING_FOR_USER',
  },
  { value: SUB_SERVICE_ORDER_STATUS.IN_PROGRESS, label: 'IN_PROGRESS' },
  { value: SUB_SERVICE_ORDER_STATUS.COMPLETED, label: 'COMPLETED' },
  { value: SUB_SERVICE_ORDER_STATUS.CANCELLED, label: 'CANCELLED' },
  { value: SUB_SERVICE_ORDER_STATUS.ERROR_OCCURED, label: 'ERROR_OCCURED' },
]
